import { render, staticRenderFns } from "./ContentOverlay.vue?vue&type=template&id=0c407f30"
import script from "./ContentOverlay.vue?vue&type=script&lang=js"
export * from "./ContentOverlay.vue?vue&type=script&lang=js"
import style0 from "./ContentOverlay.vue?vue&type=style&index=0&id=0c407f30&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports